import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Errors } from '../layout/Errors';
import { Row, Col, Button } from 'reactstrap';
import { Routes } from '../../config';
import { isAuthenticated } from '../../api/helper';
import './AccessDenied.scss';

const AccessDenied = () => {
  
    return (
      <div className="access-denied-page">
        <Errors title={<FormattedMessage id="app.errors.AccessDenied.page_title" />} >
          <div className="access-denied-page__content">
            { <FormattedMessage id="app.errors.AccessDenied.content" /> }
          </div>
          <Row className="access-denied-page__actions text-center">
            <Col>
              <Button className="access-denied-page__action" color="link" href={Routes.ROUTE_DASHBOARD}>
                <FormattedMessage id="navigation.dashboard"/>
              </Button>
            </Col>
            {! isAuthenticated() && <Col>

              <Button className="access-denied-page__action" color="link" href={Routes.ROUTE_LOGIN}>
                <FormattedMessage id="components.pages.static.header.login"/>
              </Button>
            </Col>
            }
          </Row>
        </Errors>
      </div>
    );
  
}

export { AccessDenied };
